import * as React from "react";
import FieldSearch from "@warda/library-ui/core/InputMultiSearch";
import OverlayWithPlaceholder from "@warda/library-ui/core/OverlayWithPlaceholder/OverlayWithPlaceholder";
import { ACT_VPORT } from "../reducer";
import FilterFileType from "./FilterFileType";
import BtnCleanFilters from "../Buttons/BtnCleanFilters";
import { useContextDispatchViewport } from "../SharePage";
import { FILENAME_FILTER_INDEX, TYPES_FILTER_INDEX } from "./constants";
import splitValue from "./utils/splitValue";
import formatAsString from "./utils/formatAsString";
const FiltersDesktop = ({ hidden, filters }) => {
    const filenamesFilter = filters[FILENAME_FILTER_INDEX];
    const typesFilter = filters[TYPES_FILTER_INDEX];
    const dispatchViewport = useContextDispatchViewport();
    const [value, setValue] = React.useState(formatAsString(filenamesFilter.value));
    const onChange = React.useCallback((value) => {
        setValue(value);
        dispatchViewport({
            type: ACT_VPORT.FILTER,
            clearAll: false,
            index: FILENAME_FILTER_INDEX,
            value: splitValue(value),
        });
    }, [dispatchViewport]);
    React.useEffect(() => {
        if (filenamesFilter.value === undefined) {
            setValue("");
        }
    }, [filenamesFilter.value]);
    if (hidden)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(OverlayWithPlaceholder, { minHeight: 30, minWidth: 330, visibleAfterCalc: true },
            React.createElement(FieldSearch, { placeholder: "Search in Sharepage...", value: value, onChange: onChange, width: 300 })),
        React.createElement(FilterFileType, { value: typesFilter.value, options: typesFilter.options }),
        React.createElement(BtnCleanFilters, { filters: filters })));
};
export default FiltersDesktop;
